import React from "react";

import indiaEmblem from "../../assets/images/india-emblem.png";
import aadhaarLogoMark from "../../assets/images/aadhaar-logo-mark.png";
import aadhaarLogoRight from "../../assets/images/aadhaar-logo-right.png";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
const AadhaarVerificationPage = ({
  mode,
  screen,

  aadhaarNumber,
  setAadhaarNumber,
   panProfile,

  aadhaarError,
  setAadhaarError,

  aadhaarStatus,

  aadhaarProfile,
  setAadhaarProfile,

  aadhaarConsent,
  setAadhaarConsent,

  aadhaarSending,

  checkAadhaarOnEnter,
  submitAadhaar,

  setAadhaarReferenceSecure,

  setScreen,

  sheet,
  closeSheet,

  aadhaarOtpDigits,
  aadhaarOtpRefs,

  handleAadhaarOtpChange,
  handleAadhaarOtpKeyDown,

  aadhaarResendTimer,
  resendAadhaarOtp,

  aadhaarOtpError,

  verifyAadhaarOtp,
  aadhaarOtpVerifying,

  formatAadhaarDisplay,
}) => {
  return (
    <>
 
      {mode === "page" && screen === "aadhaarKyc" && (
        
        <section className="fw-screen fw-screen--form fw-screen--aadhaar fw-fade">
     <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
          <h1 className="fw-title">Aadhaar Verification</h1>

          <p className="fw-sub fw-aadhaar__sub">
            Enter your Aadhaar number to verify identity. Please match details
            with your Aadhaar card.
          </p>

          <label className="fw-field">
            <span>Enter your Aadhaar Number</span>

            <input
              type="tel"
              inputMode="numeric"
              maxLength={14}
              placeholder="XXXX XXXX XXXX"
              value={formatAadhaarDisplay(aadhaarNumber)}
              disabled={!!aadhaarProfile || aadhaarSending}
              onChange={(e) => {
                const next = e.target.value
                  .replace(/\D/g, "")
                  .slice(0, 12);

                setAadhaarNumber(next);
                // setAadhaarError("");
                
                // Current behavior
                // setAadhaarStatus("");
                // setAadhaarProfile(null);
                
                if (next.length !== 12) {
                 setAadhaarError("")
                  setAadhaarReferenceSecure("");
                    return;
                }
checkAadhaarOnEnter(next);    
                // if (next.length === 12) {
                //   checkAadhaarOnEnter(next);
                // }
              }}
            />

            {aadhaarSending && (
              <em className="fw-field__info">
                Checking Aadhaar...
              </em>
            )}

            {!aadhaarSending && aadhaarError && (
              <em className="fw-error">
                {aadhaarError}
              </em>
            )}

            {!aadhaarSending &&
              !aadhaarError &&
              aadhaarStatus && (
                <em className="fw-field__ok">
                  {aadhaarStatus}
                </em>
              )}
          </label>

          {!aadhaarProfile && (
            <label className="fw-check fw-aadhaar-consent">
              <input
                type="checkbox"
                checked={aadhaarConsent}
                onChange={() => {
                  setAadhaarConsent((prev) => !prev);
                  setAadhaarError("");
                }}
              />

              <span>
                I authorize <b>Aadhaar verification</b> and receipt of{" "}
                <b>digital communications</b>.
              </span>
            </label>
          )}

          {aadhaarProfile && (
            <div className="fw-aadhaar-preview">
              <p className="fw-aadhaar-preview__ask">
                Is this information correct?
              </p>

              <div
                className="fw-aadhaar-idcard"
                role="img"
                aria-label="Aadhaar card preview"
              >
                <div
                  className="fw-aadhaar-idcard__secure"
                  aria-hidden="true"
                />

                <div
                  className="fw-aadhaar-idcard__rail"
                  aria-hidden="true"
                >
                  <span>आधार - आम आदमी का अधिकार</span>
                </div>

                <div className="fw-aadhaar-idcard__body">
                  <div className="fw-aadhaar-idcard__head">
                    <img
                      className="fw-aadhaar-idcard__emblem"
                      src={indiaEmblem}
                      alt=""
                    />

                    <div className="fw-aadhaar-idcard__govt">
                      <svg
                        className="fw-aadhaar-idcard__brush"
                        viewBox="0 0 220 36"
                        preserveAspectRatio="none"
                        aria-hidden="true"
                      >
                        <path
                          fill="#FF9933"
                          d="M4 4c28-3 58-2 86 1 34 3 62 2 96-1 8-.7 18 1 26 3-10 2-22 2-34 3-40 4-78 3-116 0C42 8 22 8 8 10 2 8 0 6 4 4z"
                        />

                        <path
                          fill="#138808"
                          d="M2 22c30-2 64 1 96 2 38 2 72 0 104-3 6-.6 14 0 18 2-14 3-34 4-52 5-46 3-90 1-132-2C24 25 10 25 4 26c-2-1-2-3-2-4z"
                        />
                      </svg>

                      <b>भारत सरकार</b>
                      <em>GOVERNMENT OF INDIA</em>
                    </div>

                    <img
                      className="fw-aadhaar-idcard__logo"
                      src={aadhaarLogoRight}
                      alt=""
                    />
                  </div>

                  <div className="fw-aadhaar-idcard__row">
                    <div
                      className="fw-aadhaar-idcard__photo"
                      aria-hidden="true"
                    >
                      <svg
                        viewBox="0 0 80 96"
                        width="100%"
                        height="100%"
                      >
                        <rect
                          width="80"
                          height="96"
                          fill="#b9bbd0"
                        />

                        <circle
                          cx="40"
                          cy="34"
                          r="18"
                          fill="#4a4a58"
                        />

                        <ellipse
                          cx="40"
                          cy="88"
                          rx="30"
                          ry="28"
                          fill="#4a4a58"
                        />
                      </svg>
                    </div>

                    <div className="fw-aadhaar-idcard__meta">
                      <p>
                        <span>Name:</span> {aadhaarProfile.name}
                      </p>

                      <p>
                        <span>DOB:</span> {aadhaarProfile.dob}
                      </p>

                      <p>
                        <span>Gender:</span>{" "}
                        {String(
                          aadhaarProfile.gender || ""
                        ).toUpperCase()}
                      </p>
                    </div>
                  </div>

                  <div className="fw-aadhaar-idcard__uid">
                    {`XXXX XXXX ${String(
                      aadhaarProfile.aadhaar || ""
                    ).slice(-4)}`}
                  </div>

                  <div className="fw-aadhaar-idcard__brand">
                    <img src={aadhaarLogoMark} alt="" />

                    <b>आधार</b>

                    <span>Aadhaar</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="fw-actions">
            <button
              type="button"
              className="fw-btn fw-btn--ghost"
              onClick={() => {
                if (aadhaarProfile) {
                  setAadhaarProfile(null);
                  setAadhaarConsent(false);
                  return;
                }

                // setScreen("/apply-new/bankSuccess");
                   setScreen("/apply-new/details");
              }}
            >
              Back
            </button>

            <button
              type="button"
              className="fw-btn fw-btn--primary"
              onClick={submitAadhaar}
              // disabled={aadhaarSending}
                disabled={
    aadhaarSending ||
    aadhaarNumber.length !== 12 ||
    !!aadhaarError
  }
            >
              {aadhaarProfile
                ? "Proceed"
                : aadhaarSending
                ? "Sending OTP..."
                : "Proceed"}
            </button>
          </div>
        </section>
      )}

{mode === "otp" && sheet === "aadhaarOtp" && (
  <>
    <h2>Enter Aadhaar OTP</h2>

    <p className="fw-sheet__sub">
      OTP sent to the mobile number linked with Aadhaar{" "}
      {/* <b>{formatAadhaarDisplay(aadhaarNumber)}</b> */}
        <b>XXXX XXXX {String(aadhaarNumber || "").slice(-4)}</b>
    </p>

    <div className="fw-otp">
      {aadhaarOtpDigits.map((digit, index) => (
        <input
          key={`aadhaar-otp-${index}`}
          ref={(el) => {
            aadhaarOtpRefs.current[index] = el;
          }}
          inputMode="numeric"
          maxLength={1}
          value={digit}
          placeholder="0"
          onChange={(e) =>
            handleAadhaarOtpChange(
              index,
              e.target.value
            )
          }
          onKeyDown={(e) =>
            handleAadhaarOtpKeyDown(index, e)
          }
        />
      ))}
    </div>

    <p className="fw-resend">
      Have not received your OTP?{" "}

      {aadhaarResendTimer > 0 ? (
        <span>
          Resend in {aadhaarResendTimer} seconds
        </span>
      ) : (
        <button
          type="button"
          onClick={resendAadhaarOtp}
          disabled={aadhaarSending}
        >
          {aadhaarSending
            ? "Sending..."
            : "Resend OTP"}
        </button>
      )}
    </p>

    {aadhaarOtpError && (
      <p className="fw-error">
        {aadhaarOtpError}
      </p>
    )}

    <div className="fw-actions">
      <button
        type="button"
        className="fw-btn fw-btn--ghost"
        onClick={closeSheet}
      >
        Cancel
      </button>

      <button
        type="button"
        className="fw-btn fw-btn--primary"
        onClick={verifyAadhaarOtp}
        disabled={
          aadhaarOtpVerifying ||
          aadhaarOtpDigits.join("").length !== 6
        }
      >
        {aadhaarOtpVerifying
          ? "Verifying..."
          : "Verify"}
      </button>
    </div>
  </>
)}
    </>
  );
};

export default AadhaarVerificationPage;